"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _ui = require("@alycecom/ui");

var _useGift2 = require("../../hooks/useGift");

var _giftResearchTypes = require("../../constants/giftResearchTypes.constant");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette,
      spacing = _ref.spacing;
  return {
    spaceAround: {
      paddingLeft: spacing(2),
      paddingRight: spacing(2)
    },
    linkGroup: {
      paddingTop: spacing(3),
      paddingBottom: spacing(3)
    },
    link: {
      color: palette.link.main
    },
    linkIcon: {
      marginRight: spacing(1)
    },
    linkCaption: {
      lineHeight: 1.33
    }
  };
});

var SelectProductFooter = function SelectProductFooter(_ref2) {
  var onGotoMarketplace = _ref2.onGotoMarketplace,
      totalProducts = _ref2.totalProducts,
      recipientName = _ref2.recipientName;
  var classes = useStyles();

  var _useGift = (0, _useGift2.useGift)(),
      isMarketplaceAllowed = _useGift.isMarketplaceAllowed,
      isFullResearchAllowed = _useGift.isFullResearchAllowed,
      toFullResearch = _useGift.toFullResearch,
      researchType = _useGift.researchType;

  var isInstantResult = researchType === _giftResearchTypes.researchTypes.AI;
  if (isInstantResult && !isFullResearchAllowed && !isMarketplaceAllowed) return null;

  if (isInstantResult) {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      className: classes.spaceAround,
      container: true,
      alignItems: "center",
      wrap: "nowrap",
      justifyContent: "space-between",
      direction: "row"
    }, /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/_react.default.createElement(_ui.Line, null)), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement(_ui.Circle, null, "Or")), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true,
      xs: 6
    }, /*#__PURE__*/_react.default.createElement(_ui.Line, null))), /*#__PURE__*/_react.default.createElement(_material.Grid, {
      className: classes.linkGroup,
      container: true,
      wrap: "nowrap",
      justifyContent: "center",
      direction: "row"
    }, isMarketplaceAllowed && /*#__PURE__*/_react.default.createElement(_material.Grid, {
      className: classes.spaceAround,
      item: true,
      xs: 6
    }, /*#__PURE__*/_react.default.createElement(_material.Button, {
      "data-testid": "CommonMarketplace-SelectProduct-ChooseYourOwn",
      className: classes.link,
      disableFocusRipple: true,
      variant: "text",
      fullWidth: true,
      onClick: onGotoMarketplace
    }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
      className: classes.linkIcon,
      icon: "gift",
      color: "link"
    }), "Choose your own"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: classes.linkCaption,
      gutterBottom: true,
      align: "center",
      variant: "caption"
    }, "Check out the Alyce marketplace to choose from over ", totalProducts, " gift invite options")), isMarketplaceAllowed && isFullResearchAllowed && /*#__PURE__*/_react.default.createElement(_material.Grid, {
      item: true
    }, /*#__PURE__*/_react.default.createElement(_material.Divider, {
      orientation: "vertical"
    })), isFullResearchAllowed && /*#__PURE__*/_react.default.createElement(_material.Grid, {
      className: classes.spaceAround,
      item: true,
      xs: 6
    }, /*#__PURE__*/_react.default.createElement(_material.Button, {
      "data-testid": "CommonMarketplace-SelectProduct-RequestFullResearch",
      className: classes.link,
      disableFocusRipple: true,
      variant: "text",
      fullWidth: true,
      onClick: toFullResearch
    }, /*#__PURE__*/_react.default.createElement(_ui.DashboardIcon, {
      className: classes.linkIcon,
      icon: "flask",
      color: "link"
    }), "Request full research"), /*#__PURE__*/_react.default.createElement(_material.Typography, {
      className: classes.linkCaption,
      gutterBottom: true,
      align: "center",
      variant: "caption"
    }, "Have one of our super agents personally research ", recipientName, "."))));
  }

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_material.Box, {
    p: 2
  }, /*#__PURE__*/_react.default.createElement(_material.Divider, null)), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Body-Regular-Center-Inactive"
  }, "Want to see from the ", totalProducts, " other options in the marketplace?"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    "data-testid": "CommonMarketplace-SelectProduct-CheckOutMarketplace",
    className: "Body-Regular-Center-Link-Bold Text-Pointer",
    p: 2,
    onClick: onGotoMarketplace
  }, "Check out the marketplace"), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "Subcopy-Static-Alt",
    p: 2
  }, "Protip: You can always come back to these options if you don\u2019t find anything!"));
};

SelectProductFooter.propTypes = {
  onGotoMarketplace: _propTypes.default.func.isRequired,
  totalProducts: _propTypes.default.string.isRequired,
  recipientName: _propTypes.default.string.isRequired
};
var _default = SelectProductFooter;
exports.default = _default;